// extracted by mini-css-extract-plugin
module.exports = {"container":"lazy-load-image_container__pu0oG","loading":"lazy-load-image_loading__OetB1","relative":"lazy-load-image_relative__Pt0V1"};